angular.module('jcs-autoValidate').run([
    'defaultErrorMessageResolver',
    function (defaultErrorMessageResolver)
    {
        defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages)
        {
            errorMessages['titleRequired'] = 'validationErrorMessages.titleRequiredMsg';
            errorMessages['fieldRequired'] = 'validationErrorMessages.fieldRequired';
            errorMessages['minLengthError'] = 'validationErrorMessages.minLengthErrorMsg';
            errorMessages['maxLengthError'] = 'validationErrorMessages.maxLengthErrorMsg';
            errorMessages['patternError'] = 'validationErrorMessages.fieldPatternMsg';

            errorMessages['onlyNumeric'] = 'validationErrorMessages.onlyNumeric';
            errorMessages['pleaseEnterValidLink'] = 'validationErrorMessages.pleaseEnterValidLink';
            errorMessages['pleaseEnterValidDomain'] = 'validationErrorMessages.pleaseEnterValidDomain';

            errorMessages['noMatch'] = 'validationErrorMessages.noMatch';
            errorMessages['namePattern'] = 'validationErrorMessages.namePatternMsg';
            errorMessages['emailPattern'] = 'validationErrorMessages.emailPatternMsg';
        });
    }
]);
